import { serviceRequest } from 'utils/http';
import { ProductUpdateService } from 'common/api';

export function getSiteEmployeeProductUpdatesAPI(siteEmployeeId: string) {
  return serviceRequest(() =>
    ProductUpdateService.productUpdateControllerGet(siteEmployeeId)
  );
}
